module.exports = __webpack_public_path__ + "static/img/header.c1799ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/header.jpg
// module id = 7Q5b
// module chunks = 1